// Entry point for the build script in your package.json
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "~/lib/sentry";
import { XplorApp } from "~/mariana_tek/XplorApp";

initSentry();

const root = createRoot(document.getElementById("react")!);

root.render(
  <StrictMode>
    <XplorApp />
  </StrictMode>,
);
